import { render, staticRenderFns } from "./AddTeacher.vue?vue&type=template&id=cb45e75a&scoped=true&"
import script from "./AddTeacher.vue?vue&type=script&lang=js&"
export * from "./AddTeacher.vue?vue&type=script&lang=js&"
import style0 from "./AddTeacher.vue?vue&type=style&index=0&lang=less&"
import style1 from "./AddTeacher.vue?vue&type=style&index=1&id=cb45e75a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb45e75a",
  null
  
)

export default component.exports